import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import app from './modules/app'
import test from './modules/test'
import user from './modules/user'
import permission from './modules/permission'
import tabsView from './modules/tabsView'
import approval from './modules/approval'
import flow from './modules/flow'

export { default as initStore } from './initStore'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export const store = new Vuex.Store({
    modules: {
        app,
        test,
        user,
        permission,
        tabsView,
        approval,
        flow
    },
    state: {},
    mutations: {},
    actions: {},
    getters: {},
    strict: debug,
    plugins: debug ? [createLogger()] : []
})

export default store
